var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$style.container,
    {
      [_vm.$style.containerActive]: _vm.isActive
    }
  ]},[_c('div',{class:[
    _vm.$style.avatarWrap,
    {
      [_vm.$style.blue]: _vm.iconBackgroundColor === 'blue',
      [_vm.$style.none]: _vm.iconBackgroundColor === 'none'
    }
  ]},[_vm._t("icon")],2),_c('div',{class:_vm.$style.info},[_c('div',{class:_vm.$style.topInfo},[_c('div',{class:_vm.$style.title},[_vm._t("default")],2),_c('div',{class:_vm.$style.corner},[_vm._t("corner")],2)]),_c('div',{class:_vm.$style.message},[_vm._t("info")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }